import React from 'react'
import { motion } from 'framer-motion'

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="mt-12 sm:mt-20 bg-[#171717]">
      <div className="container mx-auto px-4 sm:px-6 py-4 sm:py-6">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-gray-400 text-xs sm:text-sm text-center"
        >
          © {currentYear} | The Motorcycle Company / PVM Enterprises / MOD Enterprises
        </motion.p>
      </div>
    </footer>
  )
}

export default Footer
